var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-left" },
    [
      _c("h5", [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.t("forms.login_cred.IC_0010")) },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle",
          on: {
            click: function ($event) {
              _vm.showModal = true
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.add_a_contractor.IC_0018")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle",
          on: {
            click: function ($event) {
              _vm.showEmailModal = true
            },
          },
        }),
        _vm._v(" "),
        _c("a", {
          attrs: { href: "/forgot.php", target: "_blank" },
          domProps: { textContent: _vm._s(_vm.t("auth.forgot_password")) },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.adminInfo.email,
              expression: "adminInfo.email",
            },
          ],
          staticClass: "no-margin",
          attrs: {
            placeholder: _vm.t("register.enter_email"),
            type: "text",
            maxlength: "100",
          },
          domProps: { value: _vm.adminInfo.email },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.adminInfo, "email", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.emailError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(_vm.t("member_basic_edit.IC_0037")),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("password_change.password_new_must")),
          },
        }),
        _vm._v(" "),
        _c("ul", [
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.t("password_change.password_length")),
            },
          }),
          _vm._v(" "),
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.t("password_change.password_uppercase")),
            },
          }),
          _vm._v(" "),
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.t("password_change.password_number")),
            },
          }),
          _vm._v(" "),
          _c("li", {
            domProps: {
              innerHTML: _vm._s(_vm.t("password_change.password_common")),
            },
          }),
          _vm._v(" "),
          _c("li", {
            domProps: {
              innerHTML: _vm._s(
                _vm.t("password_change.password_constitutive_characters")
              ),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.t("forms.login_cred.IC_0004")) },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.adminInfo.password,
              expression: "adminInfo.password",
            },
          ],
          staticClass: "no-margin",
          attrs: {
            placeholder: _vm.t("register.enter_password"),
            type: "password",
            autocomplete: "off",
          },
          domProps: { value: _vm.adminInfo.password },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.adminInfo, "password", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.passwordError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("eInvoicing.password_meet_requirements")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.t("forms.login_cred.IC_0006")) },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.adminInfo.passwordMatch,
              expression: "adminInfo.passwordMatch",
            },
          ],
          staticClass: "no-margin",
          attrs: {
            placeholder: _vm.t("register.re_enter_password"),
            type: "password",
            autocomplete: "off",
          },
          domProps: { value: _vm.adminInfo.passwordMatch },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.adminInfo, "passwordMatch", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.passwordMatchError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.newcontractor.server.IC_0014")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(
              _vm.t("forms.login_cred.IC_0007") +
                " " +
                _vm.t("forms.login_cred.IC_0008")
            ),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle",
          on: {
            click: function ($event) {
              _vm.showCaptchaModal = true
            },
          },
        }),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              src: _vm.captchaSource,
              alt: "CAPTCHA",
              width: "84",
              height: "27",
            },
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-refresh",
            staticStyle: { "font-size": "20px" },
            on: { click: _vm.resetCaptcha },
          }),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.adminInfo.captcha,
              expression: "adminInfo.captcha",
            },
          ],
          staticClass: "no-margin",
          attrs: { type: "text", maxlength: "4" },
          domProps: { value: _vm.adminInfo.captcha },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.adminInfo, "captcha", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.captchaError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.newcontractor.server.IC_0034")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "columns large-4" }, [
          _vm._v("\n       \n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-4" }, [
          _c("button", {
            staticClass: "tiny radius expand",
            domProps: { textContent: _vm._s(_vm.t("register.user_guide")) },
            on: { click: _vm.openGuide },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-1" }, [
          _vm._v("\n       \n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-3" }, [
          _c("button", {
            staticClass: "tiny radius expand",
            domProps: {
              textContent: _vm._s(_vm.t("member_basic_edit.IC_0013")),
            },
            on: { click: _vm.saveAdminContact },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            {
              attrs: { size: "small", "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("p", {
                staticClass: "modalMargin",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.t("forms.login_cred.IC_0000") +
                      " " +
                      _vm.t("forms.login_cred.IC_0001")
                  ),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailModal
        ? _c(
            "modal",
            {
              attrs: { "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showEmailModal = false
                },
              },
            },
            [_c("p", [_c("email")], 1)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCaptchaModal
        ? _c(
            "modal",
            {
              attrs: { size: "small", "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showCaptchaModal = false
                },
              },
            },
            [_c("p", { domProps: { innerHTML: _vm._s(_vm.captchaHtml) } })]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }